import TarifasView from '../TarifasView.vue'
import BasePriceList from '../Pages/BasePriceList.vue'
import CalculatedPriceList from '../Pages/CalculatedPriceList.vue'
import PriceRules from '../Pages/PriceRules.vue'

const routes = [
  {
    path: '/tarifas',
    component: TarifasView,
    name: 'tarifas',
    children: [
      {
        path: 'precios-base',
        name: 'tarifas-base-price-list',
        component: BasePriceList,
      },
      {
        path: 'tarifario',
        name: 'tarifas-tarifario',
        component: CalculatedPriceList,
      },
      {
        path: 'reglas',
        name: 'tarifas-price-rules',
        component: PriceRules,
      },
    ],
  },
]

export default routes
